export default {
    it: {
     
        "first_name-field-not-ok": "Perfavore inserisci il nome",
        "first_name": "Nome",

        "error_flux_code": "Codice errore invio flusso trasmissione",
        "error_flux_code-field-not-ok": "Perfavore inserisci codice valido",
        "error_flux_code-placeholder": "Codice errore invio flusso trasmissioni",

        "last_name": "Cognome",
        "last_name-field-not-ok": "Perfavore inserisci il cognome",
        
        "mobile": "Recapito telefonico",
        "mobile-field-not-ok": "Perfavore un recapito telefonico valido",
        
        
        "telefon": "Recapito telefonico",
        "telefon-field-not-ok": "Perfavore un recapito telefonico valido",

        "pec":  "Indirizzo PEC",
        "pec-field-not-ok": "Perfavore inserisci un indirizzo email PEC valido",
        "pec-placeholder": "indirizzo pec",

        "email": "Indirizzo e-mail",
        "email-field-not-ok": "Perfavore inserisci un indirizzo email valido",
        

        "piva": "Partita IVA",
        "piva-field-not-ok": "Perfavore inserisci una partita iva valida",
        "piva-placeholder": "000000000000",

        "birthplace": "Luogo di nascita",
        "birthplace-field-not-ok": "Perfavore inserisci il luogo di nascita",
        "birthplace-placeholder": "Luogo di nascita",

        "protocol_pec": "Protocollo della comunicazione PEC.",
        "protocol_pec-field-not-ok": "Perfavore inserisci una PEC valida",
        "protocol_pec-placeholder": "Protocollo della comunicazione PEC.",

        "codfisc": "Codice Fiscale",
        "codfisc-field-not-ok": "Perfavore inserisci un codice fiscale valido",
        "codfisc-placeholder": "XXXXXX00X00X000X",

        "idcode": "Codice ID del soggetto iscritto agli Elenchi e/o Registri OAM",
        "idcode-field-not-ok": "Perfavore inserisci un codice ID valido",
        "idcode-placeholder": "Inserisci il tuo id code",


        "form-field-ok": "Ok!",
       
       
        "submit-request": "Invia richiesta",
        "terms-and-conditions": "Autorizzo il trattamento dei miei dati personali ai sensi del D.Lgs. 196/2003 e all’art. 13 GDPR 679/16.",
        "terms-and-conditions-not-ok": "Devi accettare prima di procedere",
        "privacy": "Consenso per la ",
        
    },
    en: {
       
        "first_name": "Name",
        "first_name-field-not-ok": "Please choose a name",

        "last_name": "Surname",
        "last_name-field-not-ok": "Please choose a surname",

        "mobile": "Phone number",
        "mobile-field-not-ok": "Please choose a valid phone number",

        "telefon": "Phone number",
        "telefon-field-not-ok": "Please choose a valid phone number",

        "email": "Email",
        "email-field-not-ok": "Please a valid email",

        "error_flux_code": "Transmission flow sending error code",
        "error_flux_code-field-not-ok": "Please enter a valid error code",
        "error_flux_code-placeholder": "Transmission flow sending error code",

        "piva": "VAT number",
        "piva-field-not-ok": "Please choose a valid VAT number",
        "piva-placeholder": "000000000000",

        "protocol_pec": "PEC communication protocol.",
        "protocol_pec-field-not-ok": "Please enter a valid PEC",
        "protocol_pec-placeholder": "PEC communication protocol",

        "pec":  "PEC address",
        "pec-field-not-ok": "Please enter a valid PEC address",
        "pec-placeholder": "PEC address",

        "codfisc": "Tax ID code",
        "codfisc-field-not-ok": "Please choose a valid Tax ID code",
        "codfisc-placeholder": "XXXXXX00X00X000X",

        "birthplace": "Birth place",
        "birthplace-field-not-ok": "Please enter your birth place",
        "birthplace-placeholder": "Birth place",

        "idcode": "ID code of the person registered in the OAM Lists and / or Registers",
        "idcode-field-not-ok": "Please choose a valid code id",
        "idcode-placeholder": "Enter your id code",

        "form-field-ok": "Ok!",
        
        "submit-request": "Submit request",
        "terms-and-conditions": "I authorize the processing of my personal data pursuant to Legislative Decree 196/2003 and to the article 13 GDPR 679/16.",
        "terms-and-conditions-not-ok": "You must agree before submitting",
        "privacy": "Consent for ",
   
    }
}